function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  // summary.addEventListener('click', (event) => {
  //   event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));

  //   if (window.innerWidth > 990) {
  //     const header = document.querySelector('sticky-header') ?? false;
  //     const sectionHeader = header.parentElement ?? false;
  //     const currentScrollTop = 0;
  //     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  //     if (header && !sectionHeader.classList.contains('scrolled-past-header') && !event.currentTarget.closest('details').hasAttribute('open')){
  //       header.classList.add('headerCustomColor')
  //     } else if (header 
  //       && event.currentTarget.closest('details').hasAttribute('open') 
  //       && !header.parentElement.classList.contains('scrolled-past-header')
  //       && scrollTop !== currentScrollTop) {
  //       header.classList.add('headerCustomColor')
  //     } else {
  //       header.classList.remove('headerCustomColor')
  //     }
  //   }
  // });

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (window.innerWidth > 990) {
    if (!summary.classList.contains('maje-list-menu__item')) return
    summary.addEventListener('mouseenter', (event) => {
      event.currentTarget.closest('details').setAttribute('open', true);
  
        const header = document.querySelector('sticky-header') ?? false;
        const sectionHeader = header.parentElement ?? false;
        const currentScrollTop = 0;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
        if (header && !sectionHeader.classList.contains('scrolled-past-header') && event.currentTarget.closest('details').hasAttribute('open')){
          header.classList.add('headerCustomColor')
        } else if (header && event.currentTarget.closest('details').hasAttribute('open') && !header.parentElement.classList.contains('scrolled-past-header') && scrollTop !== currentScrollTop) {
          header.classList.add('headerCustomColor')
        } else {
          // header.classList.remove('headerCustomColor')
        }
    });
  
    const headerMenu= summary.closest('header-menu')
    if(headerMenu){
      headerMenu.addEventListener('mouseleave', (event) => {
        event.currentTarget.querySelector('details').removeAttribute('open');
        const header = document.querySelector('sticky-header') ?? false;
        header.classList.remove('headerCustomColor')
      });
    }
  }

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
    if (this.getAttribute('data-is-product')) {
      this.loadProductVideo()
    }
  }

  loadProductVideo() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
    window.scrollTo({ top: 0 });
  }
  
  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.toggleAddButton(true, 'Selecciona una talla', false);
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-mobile-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const productFormMobile = document.getElementById(`product-form-mobile-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonMobile = productFormMobile.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const addButtonTextMobile = productFormMobile.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      addButtonMobile.setAttribute('disabled', 'disabled');
      if (text) {
        addButtonText.textContent = text;
        addButtonTextMobile.textContent = text;
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonMobile.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      addButtonTextMobile.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }

          const complementarySwiper = this.querySelector('swiper-container.maje-complementary__container');
          const relatedSwiper = this.querySelectorAll('.related-products swiper-container');

          if (!complementarySwiper && !relatedSwiper) {
            return;
          } else if (complementarySwiper && !relatedSwiper) {

            const complementaryParams = {
              draggable: true,
              breakpoints: {
                320: {
                  slidesPerView: 1,
                },
                749: {
                  slidesPerView: 2,
                },
              },
            };

            Object.assign(complementarySwiper, complementaryParams);
            complementarySwiper.initialize();

          } else if (!complementarySwiper && relatedSwiper) {
            
            const relatedSwiperParams = {
              draggable: true,
              breakpoints: {
                320: {
                  slidesPerView: 1,
                },
                749: {
                  spaceBetween: "4px",
                  slidesPerView: 4,
                },
              },
            };

            relatedSwiper.forEach((relatedSwiper) => {
              Object.assign(relatedSwiper, relatedSwiperParams);
              relatedSwiper.initialize();
            })
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class MajeModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.dialog = this.querySelector("dialog");
    this.selector = this.querySelector('dialog select');
    this.handlers = document.querySelectorAll('.languages__handler');
    this.informationContainer = this.querySelector('.languages-info__container');
    this.form = this.querySelector('form');
    this.closeBtns = this.querySelectorAll('.languages__closeBtn');
    this.loadContent();
  }

  loadContent() {
    this.handlers.forEach((handler) => {
      handler.addEventListener('click', () => {
        this.show();
        const currency = this.selector.selectedOptions[0].getAttribute('data-currency');
        const languages = JSON.parse(this.selector.selectedOptions[0].getAttribute('data-languages'));

        this.renderContent(languages, currency);
      });
    });

    this.closeBtns.forEach((closeBtn) => {
      closeBtn.addEventListener('click', () => {
        this.close();
      });
    });

    this.selector.addEventListener('change', (event) => {
      const currency = event.target.selectedOptions[0].getAttribute('data-currency');
      const languages = JSON.parse(event.target.selectedOptions[0].getAttribute('data-languages'));

      this.renderContent(languages, currency);
    });

    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      const selectedLanguage = this.informationContainer.querySelector('input[name="language"]:checked');
      const link = selectedLanguage.getAttribute('data-link');
      window.location.href = link;
    });
  }

  renderContent(languages, currency) {
      let languagesHTML = '';
      languages.forEach((language) => {
        console.log(language);
        languagesHTML += `
          <div style="display: flex; align-items: center; gap: 10px;">
            <input type="radio" id="${language.name}" name="language" data-link="${language.link}" value="${language.name}">
            <label for="${language.name}">${language.name}</label>
          </div>
        `;
      });

      const languagesContainer = `
        <div style="display: flex; align-items: center; gap: 10px;">
          <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <rect width="16.8396" height="19" transform="matrix(-1 0 0 1 16.8396 0)" fill="url(#pattern0_0_2775)"/>
              <defs>
              <pattern id="pattern0_0_2775" patternContentUnits="objectBoundingBox" width="1" height="1">
              <use xlink:href="#image0_0_2775" transform="scale(0.00328947 0.00291545)"/>
              </pattern>
              <image id="image0_0_2775" width="304" height="343" xlink:href="data:image/png;base64,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"/>
              </defs>
          </svg>
          <h2 class="languages-container__title">Idiomas:</h2>
        </div>
        <div class="languages-info__container-languages">
          ${languagesHTML}
        </div>
      `;

      const currencyContainer = `
        <div style="display: flex; align-items: center; gap: 10px;">
          <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <rect width="16.5089" height="18" fill="url(#pattern0_0_2778)"/>
              <defs>
              <pattern id="pattern0_0_2778" patternContentUnits="objectBoundingBox" width="1" height="1">
              <use xlink:href="#image0_0_2778" transform="scale(0.00322581 0.00295858)"/>
              </pattern>
              <image id="image0_0_2778" width="310" height="338" xlink:href="data:image/png;base64,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"/>
              </defs>
          </svg>
          <h2 class="languages-container__title">Moneda:</h2>
        </div>
        <span class="languages-container__currency">${currency}</span>
      `;

      this.informationContainer.innerHTML = `
        ${languagesContainer}
        ${currencyContainer}
      `;
  }

  show() {
    this.dialog.showModal();
  }

  close() {
    this.dialog.close();
  }
}

customElements.define("maje-modal", MajeModal);

class CookiesModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.dialog = this.querySelector("dialog");
    this.closeBtns = this.querySelectorAll('.maje-cookies-modal__closeBtn');
    this.moreInfoBtn = this.querySelector('.maje-cookies-modal__policy-link');
    this.loadContent();
  }

  loadContent() {
    if (localStorage.getItem('maje-cookies-modal-closed')) {
      return;
    } else {
      this.dialog.showModal();
    }

    this.closeBtns.forEach((closeBtn) => {
      closeBtn.addEventListener('click', () => {
        localStorage.setItem('maje-cookies-modal-closed', 'true');
        this.close();
      });
    });

    this.moreInfoBtn.addEventListener('click', () => {
      localStorage.setItem('maje-cookies-modal-closed', 'true');
      this.close();
    });
  }

  show() {
    this.dialog.showModal();
  }

  close() {
    this.dialog.close();
  }
}

customElements.define("maje-cookies", CookiesModal);